import { downloadFile } from "../../../common/utils/downloadFile";
import { setError, setFormValues } from "../EditCertificateModalSlice";
import { ChangeEvent, InvalidEvent, JSX } from "react";
import { FileInputField } from "@hatch-digital-nl/abs-storybook/legacy";
import { Dispatch } from "redux";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { useState } from "react";
import { useIsEstablishmentManager } from "../../../common/utils/useIsEstablishmentManager";

interface Props {
    formValues: {
        fileName: string;
    };
    selectedCertificate: CertificateInterface;
    dispatch: Dispatch;
    setFile: (file: File | null) => void;
}

export const FileInputFieldComponent = (props: Props): JSX.Element => {
    const { formValues, selectedCertificate, dispatch, setFile } = props;
    const [fileError, setFileError] = useState<string | null>(null);
    const isEstablishmentManager = useIsEstablishmentManager();

    return (
        <div className={"c-edit-certificate-modal__form-group"}>
            <label htmlFor="file-upload-1">Upload certificaat</label>
            <FileInputField
                placeHolder={"Bestand uploaden (max. 3mb)"}
                maxFileSizeInMb={3}
                inputId={1}
                fileName={formValues?.fileName}
                onDownloadClick={() => {
                    if (isEstablishmentManager) {
                        window.open(
                            selectedCertificate.certificate_file.file_url,
                            "_blank",
                        );
                        return;
                    }

                    downloadFile(
                        selectedCertificate.certificate_file.file_url,
                        selectedCertificate.certificate_file.file_name,
                    );
                }}
                required={true}
                onDeleteClick={() =>
                    dispatch(setFormValues({ ...formValues, fileName: "" }))
                }
                onChange={({
                    event,
                    error,
                }: {
                    event: ChangeEvent<HTMLInputElement>;
                    error: string | null;
                }) => {
                    if (fileError) {
                        setFileError(null);
                    }

                    if (error) {
                        dispatch(setError(error));
                        setFile(null);
                        return;
                    }
                    const files = event?.target?.files;
                    if (files && files.length > 0) {
                        const file = files[0];
                        if (file.size < 3 * 1024 * 1024) {
                            setFile(file);
                            dispatch(setError(null));
                        }
                    }
                }}
                onInvalid={(event: InvalidEvent<HTMLInputElement>) => {
                    event.preventDefault();

                    if (
                        (event.target as HTMLInputElement).validity.valueMissing
                    ) {
                        setFileError("Certificaat ontbreekt");
                    }
                }}
            />
            {fileError && <p className={"c-error-message"}>{fileError}</p>}
        </div>
    );
};
